module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"recurrentGhgReductions":"My solution leads to recurring GHG reductions for {duration} years.","forecast":"Forecast"},"de":{"recurrentGhgReductions":"Meine Lösung führt zu wiederkehrenden THG-Reduktionen über {duration} Jahre.","forecast":"Prognose"}}')
  delete Component.options._Ctor
}
